import CreateStoreForm from './CreateStoreForm';

export default CreateStoreForm;



// WEBPACK FOOTER //
// ./src/scenes/CreateStore/components/CreateStoreForm/index.ts